import { render, staticRenderFns } from "./allProjects.vue?vue&type=template&id=1bb21572&scoped=true"
import script from "./allProjects.vue?vue&type=script&lang=js"
export * from "./allProjects.vue?vue&type=script&lang=js"
import style0 from "./allProjects.vue?vue&type=style&index=0&id=1bb21572&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb21572",
  null
  
)

export default component.exports